/**
 * API Client for backend communication
 * @deprecated Import from './api/index.js' — kept for stable import paths.
 */
export { api as default, api } from './api/index.js'
export * from './api/index.js'
